<template>
  <div>
    <div class="max-w-screen-3xl h-40 relative group bg-black">
      <img :src="getCourseDetail.banner_url" class="w-full h-40 object-cover opacity-60" :class="hasTeacherPermissionsInCourse ? 'cursor-pointer' : ''" />
      <div class="absolute top-0 left-0 w-full h-full flex flex-col justify-end xl:flex-row xl:justify-between xl:items-end p-5">
        <div class="flex items-center space-x-3 mb-2.5 xl:mb-0">
          <h1 :title="roundtables.length" class="text-white text-3xl select-none font-bold">
            RoundTables
          </h1>
          <div class="flex items-center space-x-2">
            <div v-if="getCourseDetail.google_classroom_integration.course_id" title="Google Classroom" class="w-6 cursor-pointer h-6 ring-2 bg-white ring-yellow-400 rounded-full">
              <img src="/static/google_class_round.png" />
            </div>
            <div v-if="handleSetIntegration('schoology')" title="Schoology" class="w-7 h-7 ring-1 cursor-pointer ring-blue-600 bg-white rounded-full">
              <img src="/static/integrations/Schoology.png" />
            </div>
            <div v-if="handleSetIntegration('canvas')" title="Canvas" class="w-6 h-6 ring-2 cursor-pointer bg-white ring-red-500 rounded-full">
              <img src="/static/integrations/Canvas.png" />
            </div>
            <div v-if="handleSetIntegration('microsoft')" title="Microsoft Teams" class="w-6 cursor-pointer h-6 ring-2 bg-indigo-100 ring-purple-light rounded-full flex justify-center items-center">
              <img src="/static/integrations/Microsoft.png" class="w-5 flex justify-center items-center h-5" />
            </div>
            <div v-if="handleSetIntegration('brightspace')" title="Brightspace" class="w-6 h-6 cursor-pointer ring-2 bg-white ring-white rounded-full">
              <img class="rounded-full" src="/static/integrations/Brightspace.png" />
            </div>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:space-x-2 space-y-2 lg:space-y-0">
          <div class="flex flex-row space-x-2">
            <div class="flex items-center space-x-2 bg-white border border-solid h-10 shadow-lg border-gray-200 w-80 rounded-lg px-4 opacity-90">
              <i class="fa-solid fa-magnifying-glass text-gray-700"></i>
              <input v-model="searchString" type="text" class="rounded-lg focus-within:border-white w-full border-white" placeholder="Search..." />
            </div>
            <DropdownMenu>
              <template v-slot:toggle>
                <button class="bg-white opacity-90 h-10 w-56 rounded-lg py-2 px-4 flex text-gray-700 items-center shadow-lg justify-between space-x-2">
                  <span v-if="selected_type === 'All'">All Discussions</span>
                  <span v-if="selected_type === 'Written'">Written RoundTable</span>
                  <span v-if="selected_type === 'Verbal'">Verbal RoundTable</span>
                  <span v-if="selected_type === 'Sequence'">Sequence</span>
                  <i class="fa-solid text-xs fa-chevron-down text-gray-700"></i>
                </button>
              </template>
              <template v-slot:menu-content>
                <ul class="absolute z-10 bg-white border border-solid w-56 py-1 px-1 border-gray-200 rounded-lg mt-2 shadow-sm">
                  <li @click="handleChangeType('All')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <div class="flex items-center justify-center rounded-full h-6 w-6 bg-blueGray-700">
                      <img src="/static/roundtable_icons/all_roundtables.svg" class="w-3 h-3" />
                    </div>
                    <span>All Discussions</span>
                  </li>
                  <li @click="handleChangeType('Sequence')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <div class="flex items-center justify-center rounded-full pl-0.5 h-6 w-6 bg-purple-light">
                      <img src="/static/roundtable_icons/sequence_icon.svg" class="w-2.5 h-2.5" />
                    </div>
                    <span>Sequences</span>
                  </li>
                  <li @click="handleChangeType('Written')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <div class="flex items-center justify-center rounded-full h-6 w-6 bg-blue">
                      <img src="/static/roundtable_icons/written_icon.svg" class="w-3 h-3" />
                    </div>
                    <span>Written RoundTable</span>
                  </li>
                  <li @click="handleChangeType('Verbal')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <div class="flex items-center justify-center rounded-full h-6 w-6 bg-green-light">
                      <img src="/static/roundtable_icons/verbal_icon.svg" class="w-3 h-3" />
                    </div>
                    <span>Verbal RoundTable</span>
                  </li>
                </ul>
              </template>
            </DropdownMenu>
          </div>
          <div class="flex flex-row space-x-2">
            <DropdownMenu>
              <template v-slot:toggle>
                <button class="bg-white opacity-90 h-10 w-28 rounded-lg py-2 px-4 flex text-gray-700 items-center justify-between space-x-2">
                  <span v-if="selected_status === 'All Status'">All Status</span>
                  <span v-if="selected_status === 'Active'" class="w-28">Active</span>
                  <span v-if="selected_status === 'Closed'" class="text-red-500">Closed</span>
                  <i class="fa-solid text-xs fa-chevron-down text-gray-700"></i>
                </button>
              </template>
              <template v-slot:menu-content>
                <ul class="absolute z-10 bg-white border border-solid w-28 border-gray-200 rounded-lg mt-2 py-1 px-1 shadow-sm">
                  <li @click="handleChangeStatus('All Status')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <span>All Status</span>
                  </li>
                  <li @click="handleChangeStatus('Active')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <span>Active</span>
                  </li>
                  <li @click="handleChangeStatus('Closed')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-red-50 flex items-center space-x-2">
                    <span class="text-red-500">Closed</span>
                  </li>
                </ul>
              </template>
            </DropdownMenu>
            <DropdownMenu>
              <template v-slot:toggle>
                <button class="bg-white opacity-90 h-10 w-32 rounded-lg py-2 px-4 flex text-gray-700 items-center justify-between space-x-2">
                  <span v-if="selected_order === ''" class="text-gray-700">Order by</span>
                  <span v-if="selected_order === 'created_at'" class="text-gray-700">Created At</span>
                  <span v-if="selected_order === 'title'" class="text-gray-700">Title</span>
                  <i class="fa-solid text-xs fa-chevron-down text-gray-700"></i>
                </button>
              </template>
              <template v-slot:menu-content>
                <ul class="absolute z-10 bg-white border border-solid w-32 border-gray-200 rounded-lg mt-2 shadow-sm py-1 px-1">
                  <li @click="handleChangeOrder('created_at')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <span>Created At</span>
                  </li>
                  <li @click="handleChangeOrder('title')" class="px-3 py-2 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                    <span>Title (A-Z)</span>
                  </li>
                </ul>
              </template>
            </DropdownMenu>
            <button v-if="hasTeacherPermissionsInCourse" @click="goToBannerTab" class="flex items-center justify-center rounded-lg bg-white opacity-90 hover:bg-primary-new_light h-10 w-10">
              <img src="/static/roundtable_icons/edit.svg" class="w-4 h-4" />
            </button>
            <button v-if="!hasTeacherPermissionsInCourse" @click="joinToRT()" class="flex items-center justify-center rounded-lg bg-pinky opacity-90 text-white h-10 px-6">
              Join RoundTable
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="px-5">
      <div class="grid grid-flow-row grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 my-5">
        <div v-if="hasTeacherPermissionsInCourse" @click="handleOpenNewRoundTable()" class="h-56">
          <div class="border hover:bg-trueGray-100 border-dashed border-coolGray-300 bg-coolGray-50 rounded-md cursor-pointer h-full flex flex-col items-center my-auto">
            <div class="center items-center text-center my-auto px-3">
              <img class="center mb-4" src="/static/logos/new_roundtable_icon.svg" />
              <p class="uppercase font-semibold text-xl text-blueGray-700 mt-3">
                New RoundTable
              </p>
            </div>
          </div>
        </div>
        <RoundTableCard
          v-for="(roundtable, index) in pageOfRoundtables"
          :key="index"
          @handleOpenModalSequence="(value) => handleOpenSequence(value)"
          :type="roundtable.content_type ? roundtable.content_type : roundtable.type"
          :title="roundtable.title"
          :updated_at="roundtable.updated_at"
          :course_name="getCourseDetail.title"
          :sequence_roundtables="roundtable.roundtables"
          :course_id="getCourseDetail.id"
          :id="roundtable.id"
          :roundtable="roundtable"
          :author_id="roundtable.author_id"
          :students_count="roundtable.students_count"
          :is_ended="roundtable.is_ended"
          :end_date="roundtable.end_date"
          :is_sample="roundtable.is_sample"
          :edlink_integrations="roundtable.edlink_integrations"
          :classroom_integration="roundtable.google_classroom_course_work_id"
          :sequence_id="roundtable.sequence_id"
          :submissions_started_written="roundtable.submissions_started"
          @duplicateRT="(roundtable) => RtToDuplicate(roundtable)"
          @editRT="(roundtable) => RtToEdit(roundtable)"
          @deleteRT="(roundtable) => RtToDelete(roundtable)"
          @showFollowUp="(roundtable) => handleStartFollowUP(roundtable)"
          @close_sequence_card="(status) => handleCloseSequence(status)"
          @handleOpenDraft="(draft) => handleClickDraft(draft)"
          :users="roundtable.users_invited"
        />
      </div>
      <div class="my-10">
        <jw-pagination
          :items="searched_roudtables"
          :pageSize="14"
          :labels="customLabels"
          @changePage="onChangeCoursesPage"
        />
      </div>
    </div>
    <div
      v-if="
        (searched_roudtables.length === 0 && searchString !== null) ||
        (searched_roudtables.length === 0 && rtStatus !== 'all') ||
        (searched_roudtables.length === 0 && rtType !== 'all')
      "
    >
      <div class="text-center mb-3">
        <i class="fa-solid fa-circle-info text-lg mb-2"></i>
        <h1 class="text-center">No RoundTables Found</h1>
      </div>
      <div class="flex justify-center">
        <button @click="clearAllFilters()" class="bg-primary rounded font-medium px-5 py-2 text-xs text-white">
          Clear Filters
        </button>
      </div>
    </div>
    <DuplicateRoundtableModal
      :rt_selected="rt_selected"
      :is_live_roundtable="rt_selected.is_active === undefined"
      @close="show_duplicate_modal = false"
      v-if="show_duplicate_modal"
    />
    <Draft 
      v-if="isDraftOpen === true" 
      :id="selectedDraft.id" 
      :type="selectedDraft.type"
      :isFollowUp="isToStartFollowUp"
      :gradeLevel="selectedGradeLevel" 
      @close="isDraftOpen = false"
      @handleOpenDraft="(draft) => handleClickDraft(draft)"
    />

    <EditWrittenRoundTable 
      v-if="show_edit_rt_modal" 
      :id="rt_selected" 
      @close="closeEditRoundtableModal"
    />
    <EditVerbalRoundTable 
      v-if="show_edit_lrt_modal" 
      :id="rt_selected" 
      @close="closeEditRoundtableModal"
    />
    
    <!-- <EditRoundtableModal
      v-if="show_edit_rt_modal"
      :rtSelected="rt_selected"
      @close="closeEditRoundtableModal"
    /> -->
    <GenerateRoundTable 
      v-if="open_create_roundtable_modal" 
      @close="handleCloseNewRoundTableModal()"
      @handleStartDraft="(info) => handleOpenDraft(info)"
    />
    <!-- <NewRoundtableModal
      v-if="open_create_roundtable_modal"
      @close="handleCloseNewRoundTableModal()"
      :outside_option="outside_option"
      :follow_up_from="roundtable_from_follow_up"
      @closeNewRtModal="closeNewRoundtableModal"
    /> -->
    <!-- <EditLiveRtModal
      v-if="show_edit_lrt_modal"
      :rt_selected="rt_selected"
      @close="closeEditRoundtableModal"
    /> -->
    <SequenceModal
      v-if="is_sequence_modal_open === true"
      @close="is_sequence_modal_open = false"
      :title="sequence_details.title"
      :course_name="sequence_details.course_name"
      :course_id="sequence_details.course_id"
      :created_at="sequence_details.created_at"
      :sequence_roundtables="sequence_details.roundtables"
      :author_id="sequence_details.author_id"
      :users="sequence_details.users"
    />
    <DeleteRoundTable
      v-if="show_delete_rt_modal"
      :roundtable_id="rt_selected.id"
      :roundtable_name="rt_selected.title"
      @delete_roundtable="(roundtable_id) => deleteRoundtable(roundtable_id)"
      @close="show_delete_rt_modal = false"
    />
    <!-- <CreateSequence 
      v-if="isFollowUpOpen === true" 
      :id="selectedRoundTableToFollow.id"
      :draftId="selectedRoundTableToFollow.draftId" 
      :type="selectedRoundTableToFollow.type"
      :course="selectedRoundTableToFollow.course"
      :currentRoundtableType="selectedRoundTableToFollow.currentRoundtableType" 
      @close="isFollowUpOpen = false" 
    /> -->
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import { orderBy } from 'lodash';
  /* Services ------------------------------------------------------------------------ */
  import URLconfigs from 'services/apiConfigs';
  import authenticationServices from 'features/authentication/authentication.services';
  import profileServices from 'services/profile/profileServices';
  import accountService from 'services/account';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';

  import GenerateRoundTable from '../../../components/modals/GenerateRoundTable/GenerateRoundTable.vue';
  import Draft from '../../../features/Drafts/Index.vue';
  import EditWrittenRoundTable from '../../WrittenRoundtables/Dialogs/EditWrittenRoundTable.vue';
  import EditVerbalRoundTable from '../../VerbalRoundtables/Dialogs/EditVerbalRoundTable.vue';
  import Axios from 'axios';
  import { WrittenFollowUpTemplate } from '../../Sequences/Templates/WrittenFollowUpTemplate';
  import CreateSequence from '../../Sequences/Index.vue';

  export default Vue.extend({
    components: {
      GenerateRoundTable,
      CreateSequence,
      Draft,
      EditWrittenRoundTable,
      EditVerbalRoundTable,
      DuplicateRoundtableModal: () =>
        import(
          'components/modals/duplicateRoundtableModal/duplicateRoundtableModal'
        ),
      EditRoundtableModal: () =>
        import('components/modals/editRoundtableModal'),
      NewRoundtableModal: () =>
        import('components/modals/New_RoundTable/NewRoundTable.vue'),
      EditLiveRtModal: () => import('components/modals/editLiveRtModal'),
      /* RoundtableCard: () => import('./roundtableCard.vue'), */
      Sequence: () => import('./Sequences/SequenceCard.vue'),
      RoundTableCard: () => import('./RoundTables/RoundTableCard.vue'),
      SequenceModal: () =>
        import('./RoundTables/Sequences/RoundTableSequenceModal.vue'),
      DropdownMenu: () =>
        import('../../onlineRoundtables/components/Dropdown/DropdownMenu.vue'),
      DeleteRoundTable: () =>
        import('components/modals/Delete_Roundtable/DeleteRoundtableModal.vue'),
    },
    data() {
      return {
        searchString: null,
        rtStatus: 'all',
        rtType: 'all',
        selected_status: 'All Status',
        selected_type: 'All',
        sort: {
          key: '',
          isAsc: false,
        },
        customLabels: {
          previous: '<',
          next: '>',
        },
        isDraftOpen: false,
        pageOfRoundtables: [],
        show_delete_rt_modal: false,
        show_duplicate_modal: false,
        show_edit_rt_modal: false,
        open_create_roundtable_modal: false,
        show_edit_lrt_modal: false,
        showByIndex: null,
        currentPage: 1,
        sequences: [],
        sequence_details: [],
        is_sequence_modal_open: false,
        selected_order: '',
        is_new_roundtable_open: false,
        outside_option: '',
        roundtable_from_follow_up: null,
        selectedDraft: null,
        selectedRoundTableToFollow: null,
        isFollowUpOpen: false,
        isToStartFollowUp: false,
        selectedGradeLevel: null,
      };
    },
    props: {
      roundtables: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    mixins: [courseSocketMixin],
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getProfile',
        'getCourseDetail',
        'getDashboardRole',
      ]),
      sorted_roundtables() {
        console.log(this.roundtables, 'roundtables');
        const list = this.roundtables.filter((r) => r.type !== 'sequence' || (r.type === 'sequence' && r.roundtables !== null));
        if (this.sort.key === 'title' || this.selected_order === 'title') {
          return orderBy(list, [(rt) => rt.title.toLowerCase()], ['desc']);
        }
        if (this.sort.key === 'created_at' || this.selected_order === 'created_at') {
          return orderBy(list, [(rt) => rt.created_at], ['desc']);
        }
        return orderBy(list, [(rt) => rt.created_at], ['desc']);
      },
      searched_roudtables() {
        let searched_list = this.sorted_roundtables;
        if (this.searchString && this.searchString.length) {
          searched_list = searched_list.filter((rt) =>
            rt.title.toLowerCase().includes(this.searchString.toLowerCase())
          );
        }
        if (this.rtType === 'online' || this.selected_type === 'Written') {
          searched_list = searched_list.filter((rt) => rt.type === 'written');
        }
        if (this.rtType === 'live' || this.selected_type === 'Verbal') {
          searched_list = searched_list.filter((rt) => rt.type === 'verbal');
        }
        if (this.selected_type === 'Sequence') {
          searched_list = searched_list.filter((rt) => rt.type === 'sequence');
        }
        if (this.rtStatus === 'active' || this.selected_status === 'Active') {
          searched_list = searched_list.filter(
            (rt) =>
              !rt.is_ended &&
              ((rt.is_active !== undefined && rt.is_published) ||
                (rt.is_active === undefined && rt.is_live))
          );
        }
        if (this.rtStatus === 'draft') {
          searched_list = searched_list.filter((rt) => {
            return (
              !rt.is_ended &&
              ((rt.is_active !== undefined && !rt.is_published) ||
                (rt.is_active === undefined && !rt.is_live))
            );
          });
        }
        if (this.rtStatus === 'closed' || this.selected_status === 'Closed') {
          searched_list = searched_list.filter((rt) => rt.is_ended);
        }
        return searched_list;
      },
    },
    methods: {
      handleOpenNewRoundTable: function () {
        if (this.getCourseDetail.id === '151035ea-b4c7-484d-a07d-3505fa895cf7') {
          const route = { name: 'dashboard' };
          this.$router.push(route);
          return;
        }
        this.open_create_roundtable_modal = true;
      },
      handleOpenDraft: function({ draft, input, gradeLevel }) {
        this.selectedDraft = draft;
        this.selectedGradeLevel = gradeLevel;
        this.$router.replace({ query: { input: input }});
        this.isDraftOpen = true;
      },
      handleClickDraft: function(draft) {
        this.selectedDraft = draft;
        this.isDraftOpen = true;
      },
      handleSetIntegration(integration) {
        const edlink_integration =
          this.getCourseDetail.edlink_integrations.find((edl) => {
            if (edl.provider_name) {
              return (
                edl.provider_name.toLowerCase() === integration.toLowerCase()
              );
            }
          });
        if (edlink_integration) {
          return true;
        }
      },
      handleOpenSequence: function (sequence) {
        this.is_sequence_modal_open = true;
        this.sequence_details = {
          roundtables: sequence.roundtables,
          title: sequence.title,
          created_at: sequence.created_at,
          course_name: sequence.course_name,
          course_id: sequence.course_id,
          author_id: sequence.author_id,
        };
        return;
      },
      createNewRoundtable() {
        this.open_create_roundtable_modal = true;
      },
      clearAllFilters: function () {
        this.searchString = null;
        this.rtStatus = 'all';
        this.rtType = 'all';
      },
      goToSettings() {
        this.$store.commit('setFecthComponent', true);
        const route = {
          name: 'course.settings.general',
          params: {
            courseID: this.getCourseDetail.id,
          },
        };
        this.$router.push(route);
      },
      goToBannerTab() {
        if (this.hasTeacherPermissionsInCourse) {
          this.$store.commit('setFecthComponent', true);
          const route = {
            name: 'course.settings.banners',
            params: {
              courseID: this.getCourseDetail.id,
            },
          };
          this.$router.push(route);
        }
      },
      closeNewRoundtableModal(rt) {
        if (rt) {
          this.goToRoundtable(rt);
        }
        this.open_create_roundtable_modal = false;
      },
      closeEditRoundtableModal(value) {
        if (value == false) {
          this.show_edit_rt_modal = false;
          this.show_edit_lrt_modal = false;
          return;
        }
        this.$store
          .dispatch('fetchCourseDetails', this.$route.params.courseID)
          .then(() => {
            this.show_edit_rt_modal = false;
            this.show_edit_lrt_modal = false;
          });
      },
      rtCreatedDate(date) {
        if (date) return moment(date).format('MMMM DD, YYYY');
        return '';
      },
      onChangeCoursesPage(page) {
        this.pageOfRoundtables = page;
      },
      sortedClass(key) {
        return this.sort.key === key
          ? `sorted ${this.sort.isAsc ? 'asc' : 'desc'}`
          : '';
      },
      sortBy(event) {
        this.sort.isAsc = true;
        this.sort.key = event.target.value;
      },
      goToRoundtable(rt) {
        this.$emit('selectedRoundtable', rt);
      },
      goToMyPortfolio() {
        if (!this.getProfile.profile_url) {
          profileServices
            .createProfile(this.getProfile.id)
            .then(({ data }) => {
              const profile_url = `${URLconfigs.universeURL}/profiles/${data.profile_url}`;
              authenticationServices.navigateToExternalWithAuth(profile_url);

              return accountService
                .completeInfo()
                .then((res) => this.$store.dispatch('setAccount', res.data));
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const profile_url = `${URLconfigs.universeURL}/profiles/${this.getProfile.profile_url}`;
          authenticationServices.navigateToExternalWithAuth(profile_url);
        }
      },
      goToUniverse() {
        const course_url = `${URLconfigs.universeURL}/roundtables/browse`;
        authenticationServices.navigateToExternalWithAuth(course_url);
      },
      RtToDuplicate(rt) {
        this.rt_selected = rt;
        this.show_duplicate_modal = true;
      },
      RtToEdit(rt) {
        if (rt.is_active !== undefined) {
          this.rt_selected = rt.id;
          this.show_edit_rt_modal = true;
        } else {
          this.rt_selected = rt.id;
          this.show_edit_lrt_modal = true;
        }
        /* if (rt.is_active !== undefined) {
          this.$store.dispatch('fetchRoundtable', rt.id).then((roundtable) => {
            this.rt_selected = roundtable;
            this.show_edit_rt_modal = true;
          });
        } else {
          this.$store.dispatch('fetchLiveDiscussion', rt.id).then((lrt) => {
            this.rt_selected = lrt;
            this.show_edit_lrt_modal = true;
          });
        } */
      },
      RtToDelete(rt) {
        this.rt_selected = rt;
        this.show_delete_rt_modal = true;
      },
      handleStartFollowUP: async function ({roundtable, newFollowUpType }) {
        const payload = {
          title: "",
          prompt: WrittenFollowUpTemplate,
          type: newFollowUpType,
          instructions: "Review the resources and the questions before the Verbal RoundTables starts. Take notes about answers that you have to the questions, and use your notepad to keep track of your ideas as the conversation unfolds.",
          user_id: this.getProfile.id,
          courses: [roundtable.course.id],
          is_follow_up: true,
          follow_up_from_id: roundtable.id,
          follow_up_from_type: roundtable.type,
          is_generated: false,
        };

        if (!this.getProfile.is_paid && this.getProfile.activity_passes === 0) {
          const toast = { type: 'Info', message: 'Sorry, you have no free RoundTables left! Delete an old RoundTable or upgrade your account!', time: 5000, upgrade: true };
          return EventBus.$emit('createToast', toast);
        }
        const draft = await Axios.post(`/api/drafts/draft`, payload);
        if (!draft) {
          throw new Error('Something happened starting roundtable creation! Please try again');
        }
        await this.$store.dispatch('useActivityPass');
        this.selectedDraft = draft.data;
        this.selectedRoundTableToFollow = { 
          id: roundtable.id,
          draftId: draft.data.id,
          currentRoundtableType: roundtable.type, 
          type: newFollowUpType, 
          course: roundtable.course,
        };
        this.isToStartFollowUp = true;
        this.isDraftOpen = true;

        /* this.isFollowUpOpen = true; */

        /* this.outside_option = AcceptedOutsideOptions.follow_up;
        if (roundtable.type === 'written' || roundtable.type === 'roundtable') {
          this.$router.replace({
            query: { page: this.$route.query.page, type: 'written' },
          });
          const roundtable_data = await this.$store.dispatch(
            'fetchRoundtable',
            roundtable.id
          );
          this.open_create_roundtable_modal = true;
          this.roundtable_from_follow_up = roundtable_data;
          return;
        }
        if (
          roundtable.type === 'verbal' ||
          roundtable.type === 'live_discussion'
        ) {
          this.$router.replace({
            query: { page: this.$route.query.page, type: 'verbal' },
          });
          const roundtable_data = await this.$store.dispatch(
            'enterLiveDiscussion',
            {
              liveDiscussionID: roundtable.id,
              courseID: this.$route.params.courseID,
            }
          );
          this.open_create_roundtable_modal = true;
          this.roundtable_from_follow_up = roundtable_data;
          return;
        }
        return; */
      },
      handleCloseNewRoundTableModal: function () {
        this.open_create_roundtable_modal = false;
        this.outside_option = '';
        this.roundtable_from_follow_up = null;
        this.$router.replace({ query: { page: this.$route.query.page } });
      },
      integration_rt_connected(rt, integration) {
        if (rt && rt.edlink_integrations && rt.edlink_integrations.length) {
          const edlink_integration = rt.edlink_integrations.find((edl) => {
            if (edl.provider_name) {
              return (
                edl.provider_name.toLowerCase() === integration.toLowerCase()
              );
            }
          });
          if (edlink_integration) {
            return true;
          }
        }
        return false;
      },
      deleteRoundtable: async function () {
        if (this.rt_selected.content_type && this.rt_selected.content_type === 'draft') {
          await this.$store.dispatch('deleteDraft', {id: this.rt_selected.id});
          await this.$store.dispatch('getRecentRoundtables');
          this.show_delete_rt_modal = false;
          return;
        }
        if (this.rt_selected.is_active !== undefined) {
          this.$store.dispatch('deleteRoundtable', { id: this.rt_selected.id, rtPage: false }).then(() => {
            const toast = { type: 'Success', message: 'RoundTable successfully deleted', time: 5000,};
            EventBus.$emit('createToast', toast);
            this.show_delete_rt_modal = false;
            this.$store.dispatch('getRecentRoundtables');
          })
          .catch(() => {
            const toast = {
              type: 'Error',
              message: 'Something went wrong, please try again.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
        } else {
          this.$store
            .dispatch('deleteDiscussion', {
              id: this.rt_selected.id,
              rtPage: false,
            })
            .then(() => {
              const toast = {
                type: 'Success',
                message: 'RoundTable successfully deleted',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
              this.show_delete_rt_modal = false;
            })
            .catch(() => {
              const toast = {
                type: 'Error',
                message: 'Something went wrong, please try again.',
                time: 5000,
              };
              EventBus.$emit('createToast', toast);
            });
        }
      },
      isStudent() {
        return this.getDashboardRole === 'student';
      },
      isOpen(rt) {
        if (rt.author_id != this.getProfile.id) {
          if (rt.users[0].submission) {
            return rt.users[0].submission.opened;
          } else if (rt.users[0].participation) {
            return rt.users[0].participation.opened;
          }
        }
      },
      joinToRT() {
        EventBus.$emit('open-join-course-modal');
      },
      handleChangeStatus: async function (status) {
        this.selected_status = status;
        return;
      },
      handleChangeType: async function (type) {
        this.selected_type = type;
        return;
      },
      handleChangeOrder: async function (order_by) {
        this.selected_order = order_by;
        return;
      },
    },
    beforeDestroy: async function () {
      const { courseID } = this.$route.params;
      this.leaveCourseSocket(courseID);
    },
    mounted: async function () {
      const { courseID } = this.$route.params;
      this.setupCourseSocket(courseID);
      this.currentPage = this.$route.query.page;
      console.log(this.pageOfRoundtables, 'pageRoundTables');
    },
  });
</script>



// WEBPACK FOOTER //
// roundtablesCourseTable.vue?55453717